import { gql } from "@/gql/__generated__/gql";
import { ToolHashType } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";

const JOB_START = gql(`
  mutation JOB_START($toolHash: ID!, $hashType: ToolHashType!) {
    jobStart(toolHash: $toolHash, hashType: $hashType){
      id
      proxyUrl
      status
    }
  }
`);

type Props = {
  toolHash: string;
  hashType: ToolHashType;
};

export const useJobStart = ({ toolHash, hashType }: Props) => {
  const mutation = useMutation(JOB_START, {
    variables: { toolHash, hashType }
  });
  return mutation;
};
